/* Selection persistence — localStorage today, will move to user_profile
   on the server once Supabase is wired (Phase 3). The shape of the
   stored object stays identical so the swap is a single import change. */

import type { Selection } from '../data/types';

const KEY = 'cybhi:selection:v1';

const EMPTY: Selection = {
  pathway: null,
  subPathwayC: null,
  scenarios: [],
};

export function loadSelection(): Selection {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...EMPTY };
    const parsed = JSON.parse(raw) as Partial<Selection>;
    return {
      pathway: parsed.pathway ?? null,
      subPathwayC: parsed.subPathwayC ?? null,
      scenarios: Array.isArray(parsed.scenarios) ? parsed.scenarios : [],
    };
  } catch {
    return { ...EMPTY };
  }
}

export function saveSelection(s: Selection): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* localStorage can throw in private-mode Safari etc — silently ignore */
  }
}

export function clearSelection(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export const EMPTY_SELECTION = EMPTY;
